import React, { useState, useEffect, useMemo } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import {
  MarkerWrapper
} from 'components/underwrite/shared/map';
import { withStyles } from '@material-ui/core/styles';
import { GoogleMap, useJsApiLoader } from "@react-google-maps/api";
import { googleMapsApiKey } from "index";
import { Constants } from 'utilities/constants';

const scriptLibraries = ['geometry', 'places'];

const MsrHomesMap = ({
  module,
  selectedOpportunity, selectedMarker,
  selectedMarkerLabel, propertyUWMsrHomesMarkerState,
  selectedOpportunityMsrHomes, propertyUWMsrHomesGridCurrentViewData, setSelectedMarker,
  zoom, center, mapViewType, gestureHandling
}) => {
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey,
    libraries: scriptLibraries
  })
  const [mapRef, setMapRef] = useState(null);
  useEffect(() => {
    if (!mapRef) return;

    if (selectedOpportunityMsrHomes.length) { // Set map bounds based on comp coordinates
      mapRef.getStreetView().setVisible(false);
      setDefaultBounds();
    } else if (selectedOpportunity?.latitude && selectedOpportunity?.longitude) { // If no comps found or comps still fetching, set zoom/position based on selectedOpportunity
      mapRef.setZoom(18);
      mapRef.panTo(new window.google.maps.LatLng(selectedOpportunity.latitude, selectedOpportunity.longitude));
    }
  }, [selectedOpportunityMsrHomes, mapRef]); // Only changes on first opportunity load (empty array to array of comps) or on opportunity change

  const setDefaultBounds = () => {
    const bounds = new window.google.maps.LatLngBounds();
    let shouldSetBounds = false;
    if (selectedOpportunityMsrHomes) {
      selectedOpportunityMsrHomes.forEach(bound => {
        if (bound.latitude && bound.longitude) {
          let position = new window.google.maps.LatLng(bound.latitude, bound.longitude);
          bounds.extend(position);
        }
      });
      shouldSetBounds = true;
    }
    if (selectedOpportunity && selectedOpportunity.latitude && selectedOpportunity.longitude) {
      bounds.extend(new window.google.maps.LatLng(selectedOpportunity.latitude, selectedOpportunity.longitude));
      shouldSetBounds = true;
    }
    if (shouldSetBounds) {
      mapRef.fitBounds(bounds, 50);     // This should set the zoom level to ensure all markers are inside the viewport
    }
  }

  let markers = useMemo(() =>
    selectedOpportunityMsrHomes.map(marker => (
      <MarkerWrapper
        module={module}
        key={marker.asgCompPropertyId}
        marker={marker}
        map={mapRef}
        selectedMarker={selectedMarker}
        setSelectedMarker={setSelectedMarker}
        selectedMarkerLabel={selectedMarkerLabel}
        uwType={'msrHome'}
        gridCurrentViewData={propertyUWMsrHomesGridCurrentViewData}
        iconColor={'grey'}
        iconType={'msr'}
      />
    )), [mapRef, selectedMarker, selectedMarkerLabel, JSON.stringify(propertyUWMsrHomesGridCurrentViewData), JSON.stringify(selectedOpportunityMsrHomes)]);
    if (!isLoaded) return null;
    return (
    <GoogleMap
      onLoad={map => setMapRef(map)}
      mapContainerStyle={{ height: `100%`, width: `100%` }}
      zoom={zoom}
      center={center}
      options={{
        minZoom: 4,
        maxZoom: 20,
        disableDoubleClickZoom: false,
        mapTypeId: mapViewType,
        gestureHandling: gestureHandling,
        cameraControl: false,
        zoomControl: true,
        streetViewControl: true,
        fullscreenControl: true,
        mapTypeControlOptions: {
          style: window.google.maps.MapTypeControlStyle.DROPDOWN_MENU
        }
      }}>
      {markers}
      {selectedOpportunity &&          // Add in the subject home
        <MarkerWrapper
          module={Constants.Module.POSTACQ}
          key={selectedOpportunity.id}
          marker={{ ...selectedOpportunity, isSubject: true }}
          map={mapRef}
          selectedMarker={selectedMarker}
          setSelectedMarker={setSelectedMarker}
          selectedMarkerLabel={selectedMarkerLabel}
          iconColor={'orange'}
          iconType={"house"}
          gridCurrentViewData={[selectedOpportunity.id]}
        />
      }
    </GoogleMap>
  )
};
const styles = theme => ({
  controlContainer: {
    display: 'flex',
    //background: theme.palette.background.default,
  },
  toggle: {
    border: '1px solid #bfbfbf',
  },
  ctLegend: {
    color: 'white',
    padding: '10px 10px',
    border: '1px dotted solid',
    borderRadius: '5px',
    backgroundColor: 'black',
    opacity: '0.75',
  },
  mapIcon: {
    fontSize: '1rem'
  }
});

const mapStateToProps = (state, ownProps) => {
  const moduleState = ownProps.module === Constants.Module.POSTACQ ? state.postAcqUWState : state.propertyUWState;
  return {
    propertyUWMsrHomesMarkerState: moduleState.propertyUWMsrHomesMarkerState,
    selectedMarker: moduleState.propertyUWMsrHomesMarkerState.selectedMarker,
    selectedOpportunity: ownProps.module === Constants.Module.POSTACQ ? moduleState.postAcqUWClientTask : moduleState.propertyUWClientTxnOpp,
    selectedOpportunityMsrHomes: moduleState.selectedOpportunityMsrHomes,
    propertyUWMsrHomesGridCurrentViewData: moduleState.propertyUWMsrHomesGridCurrentViewData
  }
};

const mapDispatchToProps = (dispatch) => ({
});

export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps)
)(MsrHomesMap);